import { render } from "./normalneet.vue?vue&type=template&id=2c744a1c"
import script from "./normalneet.vue?vue&type=script&lang=js"
export * from "./normalneet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__